import { useEffect, useRef, useState } from 'react';

interface HeroProps {
  scrollToSection: (sectionId: string) => void;
}

export default function Hero({ scrollToSection }: HeroProps) {
  const sectionRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section 
      ref={sectionRef}
      id="hero" 
      className={`relative min-h-screen transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
    >
      <div className="absolute inset-0 flex items-center justify-center px-4 py-8 z-0 pt-16">
        {/* PC版 */}
        <div className="hidden md:block relative">
          <div className="relative inline-block rounded-3xl overflow-hidden shadow-[0_0_50px_rgba(68,196,255,0.5)]">
            <img 
              src="https://www.irinomiyu-uuu.com/img/hero-pc.png" 
              alt="IRINO MIYU LIVE TOUR 2026 Humor is Human" 
              className="max-h-[80vh] w-auto object-contain"
            />
            
            <div className="absolute bottom-3 right-4 text-white text-base font-bold font-dotgothic" style={{
              textShadow: '2px 2px 0 #000, -2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000, 1px 1px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000'
            }}>
              ⓒHattori-Graphics
            </div>
            
            <div className="absolute bottom-12 left-0 right-0 flex flex-row gap-4 justify-center items-center px-4">
              <button
                onClick={() => scrollToSection('schedule')}
                className="px-8 py-4 bg-black/75 text-white border-4 border-white text-base hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer font-bold font-press-start"
              >
                <span>&gt;</span> SCHEDULE
              </button>
              <button
                onClick={() => scrollToSection('ticket')}
                className="px-8 py-4 bg-black/75 text-white border-4 border-white text-base hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer font-bold font-press-start"
              >
                <span>&gt;</span> GET TICKET
              </button>
            </div>
          </div>
        </div>

        {/* スマホ版 */}
        <div className="md:hidden relative w-full max-w-md mx-auto">
          <div className="relative w-full rounded-3xl overflow-hidden shadow-[0_0_50px_rgba(68,196,255,0.5)]">
            <img 
              src="https://www.irinomiyu-uuu.com/img/hero-sp.png" 
              alt="IRINO MIYU LIVE TOUR 2026 Humor is Human" 
              className="w-full h-auto"
            />
            
            <div className="absolute bottom-2 right-3 text-white text-[10px] font-bold font-dotgothic" style={{
              textShadow: '2px 2px 0 #000, -2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000, 1px 1px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000'
            }}>
              ⓒHattori-Graphics
            </div>
            
            <div className="absolute bottom-12 left-0 right-0 flex flex-col gap-3 justify-center items-center px-4">
              <button
                onClick={() => scrollToSection('schedule')}
                className="px-6 py-3 bg-black/75 text-white border-2 border-white text-xs hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer font-bold font-press-start"
              >
                <span>&gt;</span> SCHEDULE
              </button>
              <button
                onClick={() => scrollToSection('ticket')}
                className="px-6 py-3 bg-black/75 text-white border-2 border-white text-xs hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer font-bold font-press-start"
              >
                <span>&gt;</span> GET TICKET
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
